import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';

import { FuseSharedModule } from '@fuse/shared.module';

import { LoginComponent } from 'app/main/auth/components/login/login.component';
import {UnauthGuard} from '../../unauth.guard';
import {PasswordStrengthModule} from '../password-strength/password-strength.module';
import {NgxCaptchaModule} from 'ngx-captcha';

const routes = [
    {
        path     : 'auth/login',
        component: LoginComponent,
        canActivate: [UnauthGuard]
    },
    {
        path      : 'auth',
        redirectTo: 'auth/login'
    }
];

@NgModule({
    declarations: [
        LoginComponent
    ],
    imports: [
        RouterModule.forChild(routes),

        MatButtonModule,
        MatCheckboxModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        FuseSharedModule,
        PasswordStrengthModule,
        NgxCaptchaModule

    ]
})
export class LoginModule
{
}
